<template>
  <div class="kechengguanli-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-content" >
            <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
              <el-form-item label="一级类别">
                <el-select v-model="searchForm.oneid" clearable style="width: 120px" @change="getTwoClass()">
                  <el-option v-for="one in courseClass" :label="one.dName" :value="one.dOneid">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级类别">
                <el-select v-model="searchForm.twoid" :key="twokey" clearable style="width: 180px">
                  <el-option  v-for="two in twoClass" :label="two.dName" :value="two.dTwoid">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="搜索关键字">
                <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              </el-form-item>
            </el-form>
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="kcglcourseData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="#"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-image
                        class="img"
                        :src="scope.row.img_url"
                        :preview-src-list="[scope.row.img_url]"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="课程名称"
                    min-width="400"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div style="font-weight: 400;">{{scope.row.cname}}</div>
                      <div style="font-size: 12px;color:#909399">
                        <span style="color:#409EFF" v-if="scope.row.type===0"><i class="el-icon-video-play"></i> 视频</span>
                        <span style="color:#E6A23C" v-if="scope.row.type===1"><i class="el-icon-headset"></i> 音频</span>
                        <span style="color:#67C23A" v-if="scope.row.type===2"><i class="el-icon-reading"></i> 电子书</span>
                        <span style="margin-left: 10px;font-weight: normal">{{scope.row.two_name}} / {{scope.row.three_name}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="课程章节"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.chapter_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="学习人数"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.study_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="评论数量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.comment_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="views"
                    label="浏览量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.views}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="240" fixed="right" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-document" @click.stop="commentManage(scope.row)">评论管理</el-button>
                      <el-button size="mini" icon="el-icon-reading" @click.stop="studyRecord(scope.row)">学习记录</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="评论管理"
      :visible.sync="courseCommentDialogVisible"
      width="50%">
      <div class="el-dialog-div" v-loading="loadingComment">
        <el-table
          :data="courseCommentData"
          stripe
          style="width: 100%">
          <el-table-column
            type="expand">
            <template slot-scope="scope">
              <el-table
                size="mini"
                :data="scope.row.showList"
                stripe
                style="width: 100%">
                <el-table-column
                  label="序号"
                  type="index"
                  :index="indexMethod">
                </el-table-column>
                <el-table-column
                  label="回复时间"
                  width="180"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope2">
                    <span>{{scope2.row.dTime}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="回复人"
                  width="120"
                  show-overflow-tooltip>
                  <template slot-scope="scope2">
                    <span>{{scope2.row.user_name}}</span>
                    <span v-if="scope2.row.reply_name!==''">@{{scope2.row.reply_name}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="回复内容"
                  min-width="180"
                  show-overflow-tooltip>
                  <template slot-scope="scope2">
                    <span>{{scope2.row.dContent}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope2">
                    <el-button size="mini" icon="el-icon-delete"  @click.stop="delReply(scope2.row)" :loading="delReplyLoading">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            label="评论时间"
            width="180"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.dTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="评论人"
            width="120"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.user_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="评论内容"
            min-width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.dContent}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="回复数量"
            width="80"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.replyList.length}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="50"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button size="mini" @click="delComment(scope.row)" :loading="delCommentLoading"><i class="el-icon-delete"></i> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div >
    </el-dialog>
    <el-dialog
      title="学习记录"
      :visible.sync="studyRecordDialogVisible"
      width="50%">
      <div class="el-dialog-div" v-loading="loadingStudy">
        <el-table
          :data="studyRecordData"
          stripe
          style="width: 100%;margin-bottom: 10px">
          <el-table-column
            label="学习用户"
            width="180"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope" >
              <span>{{scope.row.user_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="学习时间"
            width="180"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.time}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="学习至"
            width="80"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :disable-transitions="true" size="mini" type="warning">{{scope.row.percent}}%</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="学习章节"
            min-width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.chapter_name}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="studyRecordTotal>0"
          background
          @size-change="studyRecordHandleSizeChange"
          @current-change="studyRecordCurrentChange"
          :current-page="studyRecordCurrentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="studyRecordPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="studyRecordTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getUser } from '@/utils/auth'
import { getKcglCourseList, getCourseCommet, deleteReply, deleteComment, selectStudyRecord, getCourseClass } from '@/api/work'
import { getCourseList } from '@/api/study/course'
import men from '@/assets/photo_men.jpg'
import women from '@/assets/photo_women.jpg'

export default {
  name: 'kechengguanli',
  computed: {
    user: getUser
  },
  data() {
    return {
      delReplyLoading: false,
      delCommentLoading: false,
      twokey: '',
      searchForm: {
        oneid: null,
        twoid: null,
        search: ''
      },
      men: men,
      women: women,
      cid: null,
      dCrid: null,
      dComid: null,
      courseClass: [],
      twoClass: [],
      loadingComment: false,
      loadingStudy: false,
      studyRecordDialogVisible: false,
      studyRecordData: [],
      courseCommentDialogVisible: false,
      courseCommentData: [],
      studyRecordPageSize: 10,
      studyRecordCurrentPage: 1,
      studyRecordTotal: 0,
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      kcglcourseData: [],
      search: '',
      twoid: '',
      oneid: '',
      sort: 0
    }
  },
  created() {
    this.getKcglCourseData()
    this.getCourseClassData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getKcglCourseData()
    },
    getTwoClass() {
      this.searchForm.twoid = null
      if (this.searchForm.oneid !== '' && this.searchForm.oneid !== null && this.searchForm.oneid !== undefined) {
        for (const d of this.courseClass) {
          if (d.dOneid === this.searchForm.oneid) {
            this.twoClass = d.twoList
            break
          }
        }
      } else {
        this.twoClass = []
      }
      this.twokey = new Date().getTime().toString()
    },
    getCourseClassData() {
      getCourseClass().then(response => {
        this.courseClass = response.data
      })
    },
    studyRecord(row) {
      this.cid = row.cid
      this.studyRecordTotal = 0
      this.studyRecordData = []
      this.selectStudyRecord()
    },
    studyRecordHandleSizeChange(val) {
      this.studyRecordPageSize = val
      this.selectStudyRecord()
    },
    studyRecordCurrentChange(val) {
      this.studyRecordCurrentPage = val
      this.selectStudyRecord()
    },
    selectStudyRecord() {
      this.studyRecordDialogVisible = true
      this.loadingStudy = true
      const data = {
        cid: this.cid,
        page: this.studyRecordCurrentPage,
        limit: this.studyRecordPageSize
      }
      selectStudyRecord(data).then(response => {
        this.studyRecordTotal = response.data.total
        this.studyRecordData = response.data.list
        this.loadingStudy = false
      }).catch(() => {
        this.loadingStudy = false
      })
    },
    delComment(row) {
      this.dComid = row.dComid
      this.deleteComment()
    },
    deleteComment() {
      this.$confirm('您确定要删除此评论吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        this.delCommentLoading = true
        const data = {
          cid: this.cid,
          dComid: this.dComid
        }
        deleteComment(data).then(response => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getCourseCommet()
          this.delCommentLoading = false
        })
      })
    },
    delReply(row) {
      this.dCrid = row.dCrid
      this.deleteReply()
    },
    deleteReply() {
      this.$confirm('您确定要删除此评论吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        this.delReplyLoading = true
        const data = {
          cid: this.cid,
          dCrid: this.dCrid
        }
        deleteReply(data).then(Response => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getCourseCommet()
          this.delReplyLoading = false
        })
      })
    },
    commentManage(row) {
      this.cid = row.cid
      this.courseCommentData = []
      this.courseCommentDialogVisible = true
      this.getCourseCommet()
    },
    getCourseCommet() {
      this.loadingComment = true
      const data = {
        cid: this.cid,
        page: 1,
        limit: 9999999
      }
      getCourseCommet(data).then(response => {
        let commentList = response.data
        let replyPage = {}
        for (let i = 0; i < commentList.length; i++) {
          if (commentList[i].img_url === '') {
            if (commentList[i].sex === '女') {
              commentList[i].img_url = this.women
            } else {
              commentList[i].img_url = this.men
            }
          }
          let replyList = commentList[i].replyList
          replyPage[commentList[i].dComid + '_comment'] = ''
          replyPage[commentList[i].dComid + '_display'] = false
          if (replyList.length > 0) {
            commentList[i]['pageSize'] = 5
            commentList[i]['currentPage'] = 1
            commentList[i]['showList'] = []
            commentList[i]['allList'] = replyList
            commentList[i]['total'] = replyList.length
            commentList[i]['placeholder'] = ''

            for (let j = 0; j < replyList.length; j++) {
              const reply = replyList[j]
              replyList[j]['reply_name'] = ''
              if (reply.dReplyid !== 0) {
                for (let k = 0; k < replyList.length; k++) {
                  if (reply.dReplyid === replyList[k].dCrid) {
                    replyList[j]['reply_name'] = replyList[k].user_name
                  }
                }
              }
              if (j < 5) {
                commentList[i]['showList'].push(replyList[j])
              }
            }
          }
        }
        this.courseCommentData = commentList
        this.loadingComment = false
      }).catch(() => {
        this.loadingComment = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getKcglCourseData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getKcglCourseData()
    },
    getKcglCourseData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search,
        twoid: this.searchForm.twoid,
        oneid: this.searchForm.oneid,
        sort: this.sort
      }
      getCourseList(data).then(response => {
        this.kcglcourseData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
      // getKcglCourseList(data).then(response => {
      //   this.kcglcourseData = response.data.data
      //   this.total = response.data.total
      //   this.loading = false
      // }).catch(() => {
      //   this.loading = false
      // })
    },
    indexMethod(index) {
      return index + 1
    }
  }
}
</script>
<style lang="scss" scoped>
  .kechengguanli-container {
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
  .el-dialog-div{
    height: 70vh;
    overflow: auto;
  }
</style>
